import React from 'react';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
// Icons
import iconError from '../../../assets/icons/icon_circle-error.svg';

function ModalErrorExterno({ openModal, onHandleClose }) {
    return (
        <SmallModalContainer open={openModal}
            onClose={onHandleClose}>
            <Box display="flex" flexDirection="column" gap={"1rem"}>
                <Box
                    component="img"
                    sx={{ width: "54px", height: "54px" }}
                    alt="img not found"
                    src={iconError}
                />
                <Typography variant="h1">No encontramos consultorios asociados al CUIT</Typography>
                <Typography variant="h4" component="p">Verificá que el ingresado esté relacionado con el proveedor que indicaste.</Typography>
                <Typography variant="h5" component="p">Si el problema persiste, comunicate con nosotros. </Typography>
                <Box display="flex" gap={"1rem"} marginTop="1.5rem">
                    <Button
                        onClick={onHandleClose}
                        variant="contained"
                        sx={{ height: "48px", borderRadius: "16px", width: "100%" }}>
                        <Typography variant="cta" component="span">Entendido</Typography>
                    </Button>
                </Box>
            </Box>
        </SmallModalContainer>
    );
}

export default ModalErrorExterno;